/*
 *
 * FormIndicator actions
 *
 */

import {
  GET_SHOW_OTHER_INDICATOR_FAILED,
  GET_SHOW_OTHER_INDICATOR_SUCCESS,
  GET_SHOW_OTHER_INDICATOR_WATCHER,
  SET_UPDATE_OTHER_INDICATOR_FAILED,
  SET_UPDATE_OTHER_INDICATOR_SUCCESS,
  SET_UPDATE_OTHER_INDICATOR_WATCHER,
} from "./constants"

export function getShowOtherIndicatorWatcher(payload) {
  return {
    type: GET_SHOW_OTHER_INDICATOR_WATCHER,
    payload,
  }
}

export function getShowOtherIndicatorSuccess(payload) {
  return {
    type: GET_SHOW_OTHER_INDICATOR_SUCCESS,
    payload,
  }
}

export function getShowOtherIndicatorFailed() {
  return { type: GET_SHOW_OTHER_INDICATOR_FAILED }
}

export function getUpdateOtherIndicatorWatcher(payload) {
  return {
    type: SET_UPDATE_OTHER_INDICATOR_WATCHER,
    payload,
  }
}

export function getUpdateOtherIndicatorSuccess(payload) {
  return {
    type: SET_UPDATE_OTHER_INDICATOR_SUCCESS,
    payload,
  }
}

export function getUpdateOtherIndicatorFailed() {
  return { type: SET_UPDATE_OTHER_INDICATOR_FAILED }
}
